/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */
export var GUARANTEED = 'guaranteed';

/**
 * For when the code ambiguously handles cases where a bug has or hasn't occurred.
 * Generally speaking, it's recommended to try avoid writing code that results in using this value.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - Handling expected and unexpected (i.e. Outside of the server's schema or 500s) HTTP error responses with exactly the same code
 * - Using an error boundary to show an error when a component throws an exception which includes errors mentioned in {@link NONE} (like validation errors)
 */
export var MAYBE = 'maybe';

/**
 * For when the code is meant to only ever execute when no bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - 'Happy path' code
 * - HTTP 200 status code handling logic (assuming 200s only happen when the server is healthy)
 * - User validation errors
 * - Credit card rejected errors
 * - Any response bodys/HTTP statuses you were expecting to receive that do not signify that the server is experienced a bug
 */
export var NONE = 'none';